import { CommonErrorType } from '../../../types'

export enum StatusType {
  INIT = 'init',
  FETCHING = 'fetching',
  ERROR = 'error',
  FETCHED = 'fetched'
}

interface StatusInit {
  status: StatusType.INIT
}

interface StatusFetching {
  status: StatusType.FETCHING
}

interface StatusFetched<T> {
  status: StatusType.FETCHED
  data: T
}

interface StatusError {
  status: StatusType.ERROR
  error: CommonErrorType
}

export type FetchState<T> =
  | StatusInit
  | StatusFetching
  | StatusFetched<T>
  | StatusError

export type MaybeFetchState<T> = FetchState<T> | undefined

export enum ActionType {
  REQUEST,
  SUCCESS,
  FAILURE
}

export type Action<T> =
  | { type: ActionType.REQUEST }
  | { type: ActionType.SUCCESS; payload: T }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  | { type: ActionType.FAILURE; payload: any }

export interface FetchHookReturnType<T, S> {
  fetchState: FetchState<T>
  execute: (variables?: S) => Promise<void>
}

export interface FetchHookProps {
  query: string
  immediate?: boolean
}
